import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider';
import Loader from '../../Shared/Loader/Loader';

const PrivateRoute = ({children}) => {
    const { user, loading, gLoading } = useContext(AuthContext);
    const location = useLocation();

    if (loading || gLoading) {
        return <Loader />
    }

    if (!user) {
        return <Navigate to='/login' state={{from: location}} replace/>
    }

    return children;
    
};

export default PrivateRoute;